import { FC, HTMLAttributes } from "react";
import { Skeleton } from "@mantine/core";
import clsx from "clsx";

// ----------------------------------------------------------------------------

export type ILatestLeadershipBlogSkeleton = HTMLAttributes<HTMLDivElement> & {};

const LatestLeadershipBlogSkeleton: FC<ILatestLeadershipBlogSkeleton> = (
  props,
) => {
  const { className, ...other } = props;

  return (
    <div
      className={clsx(
        "grid w-full gap-5 bg-white lg:grid-cols-12 lg:gap-7",
        className,
      )}
      {...other}
    >
      {/* Image Skeleton */}
      <Skeleton
        height="100%"
        width="100%"
        className="col-span-full h-[260px] w-full rounded-none sm:h-[327px] md:h-[404px] lg:col-span-7 lg:h-[340px] xl:h-[414px]"
      />

      {/* Text Skeletons */}
      <div className="col-span-full mt-3 w-full lg:col-span-5 lg:mt-0">
        <Skeleton height={20} width="40%" className="mb-2 lg:mt-6" />
        <Skeleton height={16} width="100%" className="mt-6" />
        <Skeleton height={16} width="100%" className="mt-3" />
        <Skeleton height={16} width="70%" className="mt-3" />

        {/* Author Details */}
        <div className="mt-6 flex items-center">
          <Skeleton
            height={32}
            width={32}
            circle
            className="mr-2 rounded-full"
          />
          <Skeleton height={16} width="50%" className="" />
        </div>

        {/* Button Skeleton */}
        <Skeleton
          height={40}
          className="mb-2 mt-7 w-1/3 rounded-none lg:w-2/5"
        />
      </div>
    </div>
  );
};

export default LatestLeadershipBlogSkeleton;
